import fetch from '../fetch';
import { errorMessages } from '../../constants';

export const FETCH_ONE_TIME_PAYMENT_VALUE = 'FETCH_ONE_TIME_PAYMENT_VALUE';
export const ONE_TIME_PAYMENT_VALUE_FETCHED = 'ONE_TIME_PAYMENT_VALUE_FETCHED';
export const CLEAR_ONE_TIME_PAYMENT_VALUE = 'CLEAR_ONE_TIME_PAYMENT_VALUE';
export const ONE_TIME_PAYMENT_VALUE_FETCH_ERROR = 'ONE_TIME_PAYMENT_VALUE_FETCH_ERROR';

const endpoint = '/billingsubscriptions/subscription/billdate/calculateprice';

export default () => async (dispatch, getState) => {
  const state = getState();

  const selectedBillDate = state.billingDateSelection?.selectedBillDate;
  const eligibility = state?.billing?.dateChangeEligibility.data;
  const earliestSelectableDate = eligibility?.earliestSelectableDate;
  const planPrice = eligibility?.planPrice;

  dispatch({ type: FETCH_ONE_TIME_PAYMENT_VALUE });

  const fetched = {
    type: ONE_TIME_PAYMENT_VALUE_FETCHED,
  };

  try {
    const requestBody = {
      method: 'POST',
      body: {
        selectedBillDate,
        earliestSelectableDate,
        planPrice,
      },
    };

    const oneTimePayment = await dispatch(fetch(endpoint, requestBody));
    fetched.payload = { ...oneTimePayment.data[0] };
  } catch (error) {
    const errorMessage = {
      heading: errorMessages.someDataMissing,
      messages: [errorMessages.technicalIssues],
    };

    fetched.type = ONE_TIME_PAYMENT_VALUE_FETCH_ERROR;
    fetched.payload = new Error(JSON.stringify(errorMessage));
  }

  dispatch(fetched);
};

export const clearOneTimePaymentValue = () => ({
  type: CLEAR_ONE_TIME_PAYMENT_VALUE,
});
